import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const IS_NAVIGATION_IN_PROGRESS_TOKEN = new InjectionToken<
  Observable<boolean>
>('IS_NAVIGATION_IN_PROGRESS_TOKEN');
